import React, { useEffect } from 'react';
import logo from '../images/logo.png';
import ActiveUsersList from './components/ActiveUsersList/ActiveUsersList';
import * as webRTCHandler from '../utils/webRTC/webRTCHandler';
import * as webRTCGroupHandler from '../utils/webRTC/webRTCGroupCallHandler';
import DirectCall from './components/DirectCall/DirectCall';
import { connect } from 'react-redux';
import { callStates } from '../Actions/callActions';
import GroupCallRoomsList from './components/GroupCallRoomsList/GroupCallRoomsList';
import GroupCall from './components/GroupCall/GroupCall';
import './Dashboard.css';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';


const Dashboard = ({callState }) => {
  useEffect(() => {
    webRTCHandler.getLocalStream();
    webRTCGroupHandler.connectWithMyPeer();
  }, []);

  return (
    <>
    <Header />
    <div className='dashboard_container background_main_color'>
      <div className='dashboard_left_section'>
        <div className='dashboard_content_container'>
          <DirectCall />
          {/* <GroupCall /> */}
          {callState !== callStates.CALL_IN_PROGRESS}
        </div>
        {/* <div className='dashboard_rooms_container background_secondary_color'>
          <GroupCallRoomsList />
        </div> */}
      </div>
      <div className='dashboard_right_section background_secondary_color'>
        <div className='dashboard_active_users_list'>
          <ActiveUsersList />
        </div>
        {/* <div className='dashboard_logo_container'>
          <img className='dashboard_logo_image' src={logo} alt='logo' />
        </div> */}
      </div>
    </div>
    <Footer/>
    </>
  );
};

const mapStateToProps = ({ call, dashboard }) => ({
  ...call,
  ...dashboard
});

export default connect(mapStateToProps)(Dashboard);
